/**
 * @generated SignedSource<<ca3009086e69c8e7308fa879403c738a>>
 * @relayHash 0b75dbc1c9714654715ad983c8cb51c3
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/418.0.0-2023-06-12T15:05:27.617Z/ControlledAddressFormRefetchQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ControlledAddressFormRefetchQuery$variables = {
  canCheckZipCode: boolean;
  country?: string | null;
  zipCode?: string | null;
};
export type ControlledAddressFormRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"ControlledAddressForm_viewer">;
  };
};
export type ControlledAddressFormRefetchQuery = {
  response: ControlledAddressFormRefetchQuery$data;
  variables: ControlledAddressFormRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canCheckZipCode"
},
v1 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "country"
},
v2 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "zipCode"
},
v3 = {
  "kind": "Variable",
  "name": "country",
  "variableName": "country"
},
v4 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "abbreviation",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ControlledAddressFormRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "canCheckZipCode",
                "variableName": "canCheckZipCode"
              },
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ControlledAddressForm_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ControlledAddressFormRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Geography",
            "kind": "LinkedField",
            "name": "geography",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "kind": "LinkedField",
                "name": "countries",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "kind": "LinkedField",
                "name": "usStates",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "canCheckZipCode",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "zipCodeLookUp",
                "args": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "zipCode",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/418.0.0-2023-06-12T15:05:27.617Z/ControlledAddressFormRefetchQuery",
    "metadata": {},
    "name": "ControlledAddressFormRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "175ba9dac8426a70568b1e410d0cc4fb";

export default node;
